module.exports = __webpack_public_path__ + "static/img/hyper-tube-entrance_64.1a90a09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hyper-tube-entrance_64.png
// module id = ZCcM
// module chunks = 0